import { InputState, LABEL_TYPE } from '../types/inputTheme';
export const getFontSize = (state, type, component, styles, placeholder) => {
    if (styles?.[state]?.label?.type !== LABEL_TYPE.STANDARD &&
        placeholder &&
        state !== InputState.ACTIVE) {
        return styles?.[InputState.ACTIVE]?.[component]?.[type];
    }
    return styles?.[state]?.[component]?.[type];
};
//# sourceMappingURL=fontSize.utils.js.map